module.exports = __webpack_public_path__ + "static/images/index-rule.bc9f1ddde.png";